module.exports = __webpack_public_path__ + "static/media/peda_page_cover_page.87aaa9fc.png";